// extracted by mini-css-extract-plugin
export default {"container":"hvJvqJGx2zkYJN3lKual","row":"OVwE52jp020TnjRveQT9","totalRow":"tmWunYbqryVsZTTfkLgf","nestedInfo":"Hn33tNe8PMCIPuxPc34J"};